<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: "DIOデジタル株式会社｜インプラント・歯科医療用各種機器・材料",
    meta: [
      { name: "description", content: "" },
      { name: "keywords", content: "" },
    ],
  },
  async created() {
    if (sessionStorage.getItem("access") == null) {
      console.log("access");
      sessionStorage.setItem("access", "1");
      location.reload(true);
    } else {
      console.log("in session");
    }
  },
};
</script>
<style lang="scss">
@use "@/css/utility/_colors" as colors;
@use "@/css/utility/_mixin" as mixin;
@use "@/css/utility/_media" as media;
@use "@/css/utility/_font" as font;
@use "@/css/utility/_variables" as variables;
html {
  scroll-behavior: smooth;
}
body {
  background: #e5e5ea;
  width: 100%;
  height: 100%;
}
main {
  box-sizing: border-box;
  padding: 60px 60px 50px 260px;

  @include mixin.liquidSize(padding-top, 120, 100);
  @include mixin.liquidSize(padding-bottom, 50, 50);
  @include mixin.liquidSize(padding-left, 60, 15);
  @include mixin.liquidSize(padding-right, 60, 15);
}
#title {
  font-size: 24px;
  font-weight: 700; /* bold */
  letter-spacing: 0.08em;
  @include mixin.liquidSize(margin-bottom, 60, 40);
  position: relative;
  width: 100%;
  text-align: center;
  .btns {
    justify-content: flex-start;
    position: absolute;
    top: 0;
    right: 0;
  }
}

.m-card-1 {
  background: #fcfcfc;
  border: 1px solid #e9e9e9;
  border-radius: 3px;
  box-sizing: border-box;
  //padding: 20px 30px 20px 20px;
  box-shadow: 10px 10px 50px rgba(20, 20, 20, 0.11);
  @include mixin.liquidSize(padding-top, 20, 20);
  @include mixin.liquidSize(padding-bottom, 20, 20);
  @include mixin.liquidSize(padding-left, 20, 20);
  @include mixin.liquidSize(padding-right, 20, 20);
}
.m-card-1__title {
  font-size: 13px;
  @include mixin.liquidSize(font-size, 13, 13);
  font-weight: 700; /* bold */
  letter-spacing: 0.05em;
  margin-bottom: 10px;
  color: #89868b;
}
/* フェードイン・フェードアウト中の設定 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
/* フェードイン開始時・フェードアウト終了時の設定 */
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
//datepicker
.datepicker {
  input {
    @include mixin.liquidSize(width, 200, 139);
    @include mixin.liquidSize(height, 40, 40);
    box-sizing: border-box;
    border-radius: 6px;
    border: solid 1px #e9e9e9;
    @include mixin.liquidSize(padding-left, 15, 15);
    @include mixin.liquidSize(padding-right, 15, 15);
    background: {
      image: url(./assets/icon-calendar.svg);
      size: 20px auto;
      position: center right 15px;
      repeat: no-repeat;
    }
    &.error {
      background-color: #ffd5d5;
    }
  }
  .vdp-datepicker__clear-button {
    position: absolute;
    top: 50%;
    right: 15px;
    translate: 0% -50%;

    color: #fff;
    font-size: 15px;
    letter-spacing: 0.05em;
    border-radius: 6px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
    i {
      display: none;
    }
  }
  &.has-value {
    &:hover {
      .vdp-datepicker__clear-button {
        opacity: 1;
        pointer-events: all;
        width: 50px;
        height: 30px;
        background: #de2817;
        &:after {
          content: "削除";
        }
      }
    }
  }
}
</style>
